const createCollectionItemsArray = (items, productId) => {
  let itemIds = []
  items.map((item) => {
    itemIds.push({ itemId: item.originalId, productId: productId })
  })
  return itemIds
}
export default createCollectionItemsArray
